import i18n from '@/plugins/i18n';
import { useConfirmStore } from '@/stores/confirmStore';

export function useConfirmation() {
    const confirmStore = useConfirmStore();

    async function onConfirm(
        title: string = i18n.global.t('common.deleteConfirmationTitle'),
        text: string = i18n.global.t('common.deleteConfirmationText'),
    ): Promise<boolean> {
        return new Promise((resolve: (result: boolean) => void) => {
            confirmStore.resolve = resolve;
            confirmStore.title = title;
            confirmStore.text = text;
            confirmStore.open = true;
        });
    }

    return { onConfirm };
}
